import Employees from 'pages/employees/list';


export const List = () => {
    return (
        <Employees pageAccess="enrolled" />
    )
}


export default List;